module.exports = __webpack_public_path__ + "img/pghheli2_thumb.b7dec1c3.jpg";